import React, { useState } from 'react'
import ScriptSetting from './ScriptSetting'
import TPVScriptList from "./TPVScriptList"

const TPVScript = () => {
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [settingsAdded,setSettingsAdded]=useState<boolean>(true)
  const openModal = () => {
    setShowCreateAppModal(true)    
  }

  const handleClose = () => {
    setShowCreateAppModal(false)
  }

  return (
    <>
      <div
        className='d-flex flex-row justify-content-between align-items-center mb-5'
      >
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>TPV Script List</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - TPV Script</span>
        </div>
        <div className=''>
          <button
            className='btn btn-primary fs-7'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={(e) => openModal()}
          >
            <span>
              <i className='bi bi-gear-fill fs-6'></i>
            </span>
            Script Settings
          </button>
          { <ScriptSetting  showCreateAppModal={showCreateAppModal} handleClose={handleClose} settingsAdded={settingsAdded} setSettingsAdded={setSettingsAdded} /> }

        </div>
      </div>
      <TPVScriptList settingsAdded={settingsAdded}/>     
      </>)
}
export default TPVScript
